let size;

/**
 * On MacOS this will always return 0 with the default setting for
 * "Show scroll bars" in System Preferences. When set to "Always"
 * it returns a number as expected. On other platforms it should
 * always return a number.
 *
 * @returns {number} The width of the scrollbar in pixels.
 */
export function getScrollbarWidth() {
  if (typeof size === 'undefined') {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
  }
  return size;
}